import { Navigate } from 'react-router-dom';
import { useAssistantAccess } from 'src/hooks/useAssistantAccess';

/**
 * Enveloppe une route hors du périmètre "Entreprises". Cacher l'entrée de menu ne
 * suffit jamais à protéger une page — un compte SUPER_ADMIN_ASSISTANT qui tape
 * directement l'URL est ici redirigé vers la liste des entreprises. La vraie
 * protection reste côté backend (RoleGuard/PermissionGuard) : ceci n'est qu'un
 * confort de navigation, pas la ligne de défense.
 */
function AssistantRestrictedRoute({ children }) {
  const { isAssistant } = useAssistantAccess();
  if (isAssistant) return <Navigate to="/management/companies" replace />;
  return children;
}

export default AssistantRestrictedRoute;
